import React from 'react';
import '../App.css';

function CreateSupervisorModal({ isOpen, onClose, onAddSupervisor, newSupervisor, onInputChange }) {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <button onClick={onClose} className="modal-close-button">×</button>
        <h1>신규 감리원 등록</h1>
        <br/><hr/><br/>
        <form onSubmit={onAddSupervisor}>
          <div className="form-grid">
            <div className="form-group">
              <label>이름</label>
              <input type="text" name="name" value={newSupervisor.name} onChange={onInputChange} />
            </div>
            <div className="form-group">
              <label>직위</label>
              <input type="text" name="position" value={newSupervisor.position} onChange={onInputChange} />
            </div>
            <div className="form-group">
              <label>생년월일</label>
              <input type="text" name="birthDate" value={newSupervisor.birthDate} onChange={onInputChange} placeholder="YYYY-MM-DD" />
            </div>
            <div className="form-group">
              <label>연락처</label>
              <input type="text" name="phone" value={newSupervisor.phone} onChange={onInputChange} />
            </div>
            <div className="form-group">
              <label>이메일</label>
              <input type="email" name="email" value={newSupervisor.email} onChange={onInputChange} />
            </div>
          </div>
          <div className="form-group">
            <label>비고</label>
            <textarea name="notes" value={newSupervisor.notes} onChange={onInputChange} style={{ width: '100%', minHeight: '100px' }}></textarea>
          </div>
          <div className="form-actions">
            <button type="submit" className="submit-button">등록하기</button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default CreateSupervisorModal;
